export default __webpack_public_path__ + "static/alloy-23fc862cd1a18041d34931be027adc5a.png";